import React, { useEffect, useState } from 'react'

import { Empty, Flex, Splitter } from 'antd'

import { DigitalAsset } from '../../../../modules/domain/digitalAsset/types'
import DigitalAssetTableContent from './DigitalAssetTableContent'
import CSS from 'csstype'
import DigitalAssetDetail from './DigitalAssetDetail'
import { Status, UploadCompanyType } from 'types/entities'
import DigitalAssetActions from '../../../../modules/domain/digitalAsset/duck'
import { useAction } from '@agro-club/frontend-shared'
import DeletedDigitalAssetsTableContent from './DeletedDigitalAssetsTableContent'
import AuthSelectors from 'modules/domain/auth/selectors'
import { useSelector } from 'react-redux'

const SplitterPanelStyles: CSS.Properties = {
  display: 'flex',
  paddingTop: '1em',
}

type DigitalAssetsListTabProps = {
  uploadCompanyType?: UploadCompanyType
  assetStatus?: Status
}

const DigitalAssetsListTab: React.FC<DigitalAssetsListTabProps> = ({
  uploadCompanyType,
  assetStatus = Status.Active,
}) => {
  //details section
  const [detailDigitalAsset, setDetailDigitalAsset] = useState<DigitalAsset>()
  const draftCleanUpAction = useAction(DigitalAssetActions.selectedFileDraftRequested)

  const uploadCompanyTypeSetAction = useAction(DigitalAssetActions.uploadCompanyTypeSet)
  uploadCompanyTypeSetAction(uploadCompanyType)
  const isAdminOrProducer = useSelector(AuthSelectors.isAdminOrProducer)
  const isAdmin = useSelector(AuthSelectors.isAdmin)
  const userCompanyType = isAdminOrProducer ? UploadCompanyType.Producer : UploadCompanyType.Distributor
  const canEditOrDelete = isAdmin || userCompanyType === uploadCompanyType
  const showUpload = userCompanyType === uploadCompanyType

  const showDigitalAssetDetails = (digitalAssetDetail: DigitalAsset) => {
    setDetailDigitalAsset(() => digitalAssetDetail)
  }

  const assetsTable = () => {
    if (assetStatus === Status.Deleted) {
      return <DeletedDigitalAssetsTableContent showAssetDetails={showDigitalAssetDetails} />
    }
    if (uploadCompanyType) {
      return (
        <DigitalAssetTableContent
          showAssetDetails={showDigitalAssetDetails}
          userCompanyType={userCompanyType}
          canEditOrDelete={canEditOrDelete}
          showUpload={showUpload}
        />
      )
    }
    return (
      <Flex align="center" justify="center" flex={1}>
        <Empty />
      </Flex>
    )
  }

  //reset selected items in case a different tab is opened
  //todo: consider removing it from redux or removing redux
  useEffect(() => {
    draftCleanUpAction([])
  }, [])

  return (
    <>
      <Splitter>
        <Splitter.Panel size="80%" resizable={false} style={SplitterPanelStyles}>
          {assetsTable()}
        </Splitter.Panel>
        <Splitter.Panel size="20%" style={{ ...SplitterPanelStyles }}>
          <DigitalAssetDetail digitalAsset={detailDigitalAsset} canEditOrDelete={canEditOrDelete} />
        </Splitter.Panel>
      </Splitter>
    </>
  )
}

export default DigitalAssetsListTab
